import React from 'react'
import {
  InformfixService,
  HomeService,
  ProjectService,
  AuthService,
  TechnicainService,
} from './../../../services'
import {
  Button,
  Select,
  message,
  Dropdown,
  Menu,
  Popconfirm,
  Form,
  Card,
  PageHeader,
  Row,
  Col,
  Input,
  List,
  Modal,
  Divider,
  Tooltip,
  Space,
  DatePicker,
  Spin,
  Badge,
  Avatar,
  Pagination,
  Tabs,
} from 'antd'
import _ from 'lodash'
import { Config } from './../../../config/index'
import './style.scss'
import PaginationDetail from '../../PaginationDetail'
import queryString from 'query-string'

import { inject, Observer } from 'mobx-react'
import InformFormAdd from './../inform-form'
import InformEdit from './../inform-edit'
import AssignJob from './../assign-job'
import InformView from './../inform-view'
import NotificationAdd from './../../notification/notification-form'
import { Moment, strlimit, openNotificationWithIcon } from '../../../helpers'
import {
  PlusCircleOutlined,
  MenuFoldOutlined,
  SearchOutlined,
  ReloadOutlined,
  ClockCircleFilled,
  EditFilled,
  CloseCircleFilled,
  CalendarFilled,
  UserOutlined,
  HomeFilled,
  FileDoneOutlined,
  WifiOutlined,
  PhoneFilled,
  HomeOutlined,
  EditOutlined,
  CalendarOutlined,
  CloseOutlined,
  PhoneOutlined,
  BellOutlined,
  PlusSquareOutlined,
} from '@ant-design/icons'
import { InformfixStatus } from '../InformfixStatus'
import iconHome from '../../../assets/images/informfix/icon-home.png'
import InformListComponent from '../InformListComponent'
import InformListPostpone from '../inform-list-postpone/index'
import { DashboardService } from '../../../services/dashboard.service'
const { TabPane } = Tabs
const IconText = ({ icon, text, onClickAction }) => (
  <React.Fragment>
    {icon} {text}
  </React.Fragment>
)

const { Option } = Select
const formatDateSearch = 'DD/MM/YYYY'

const STATUS_INFORMFIX_OPEN = Config.informfix.status.OPEN.value //  สถานะใบแจ้งซ่อม: เปิดงาน
// const STATUS_INFORMFIX_WAIT = Config.informfix.status.WAIT.value //  สถานะใบแจ้งซ่อม: รอยืนยันลูกค้า
// const STATUS_INFORMFIX_CONFIRMED = Config.informfix.status.CONFIRMED.value //  สถานะใบแจ้งซ่อม: ยืนยันลูกค้าแล้ว
const STATUS_INFORMFIX_PROCEED = Config.informfix.status.PROCEED.value // สถานะใบแจ้งซ่อม: กำลังดำเนินการ  สำหรับใช้แสดงหน้าจัดคิวงาน
const STATUS_INFORMFIX_COMPLETE = Config.informfix.status.COMPLETE.value //  สถานะใบแจ้งซ่อม: เสร็จแล้ว

@inject('informStore')
@Observer
class InformList extends React.Component {
  constructor() {
    super()
    this.state = {
      initLoading: true,
      loading: false,
      loadingProject: false,
      list: [],
      showFormAdd: false,
      showFormEdit: false,
      showFormAssign: false,
      showFormView: false,
      editId: '',
      viewId: '',
      searchParams: {
        project_id: '',
        work_status: STATUS_INFORMFIX_OPEN,
        q: '',
        f: 'id',
        technician_id: '',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
      homeDetail: {},
      inform: {},
      informJobs: [],
      galleries: [],
      photos: [],
      confirmLoading: false,
      projects: [],
      listStatus: [],
      listTechnichian: [],
      visibleMenuDropDown: false,
      formStep: '',
      countWorkstatus: [],
    }
  }

  formRef = React.createRef()

  setPageParams(params) {
    this.setState({
      pagination: {
        current: params.currentPage,
        total: params.totalCount,
        pageSize: params.perPage,
        pageCount: params.pageCount,
      },
    })
  }

  /**
   * แสดงข้อมูลตาม Filter ที่เลือกไว้
   */
  getData = () => {
    const { searchParams, pagination } = this.state
    const params = {
      page: pagination ? pagination.current : 1,
      'per-page': pagination ? pagination.pageSize : Config.pager.limit,
      project_id: searchParams.project_id,
      work_status: searchParams.work_status,
      f: searchParams.f,
      q: searchParams.q,
      technician_id: searchParams.technician_id,
    }
    this.props.informStore.setItems([])
    this.setState({
      list: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
    })

    return InformfixService.search(params)
  }

  /**
   * ดึงข้อมุลใบแจ้งซ๋อมตามหน้าที่กำหนด
   */
  loadDataPagination = () => {
    this.setState({
      initLoading: true,
      list: [],
    })
    this.getData()
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)
        this.props.informStore.setItems(data)
        this.setState(
          {
            list: data,
            initLoading: false,
          },
          () => {
            window.dispatchEvent(new Event('resize'))
          },
        )
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            // message.warning(err.response.statusText);
          }
        }
        this.setState({ initLoading: false, list: [] })
        this.props.informStore.setItems([])
      })
  }

  /**
   * ดึงข้อมุลใบแจ้งซ๋อมแบบเริ่มที่หน้า 1 และรีเซ็ต Filter ใหม่หมด
   */
  getItems = () => {
    let pagination = this.state.pagination
    pagination.current = 1
    pagination.total = 0
    pagination.pageSize = Config.pager.limit
    pagination.pageCount = 0
    this.setState({
      pagination,
      initLoading: true,
      list: [],
    })
    this.getCountWorkstatus()
    this.getData()
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)
        this.props.informStore.setItems(data)
        this.setState(
          {
            // data: data,
            list: data,
            initLoading: false,
          },
          () => {
            window.dispatchEvent(new Event('resize'))
          },
        )
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            // message.warning(err.response.statusText);
          }
        }
        this.setState({ initLoading: false, list: [] })
      })
  }

  /**
   * สำหรับปุ่มค้นหาแสดงเริ่มต้นที่หน้า 1 และ filter อื่น ๆ ยังคง filter อื่น ๆ ไว้
   */
  onSearch = () => {
    this.setState({
      list: [],
    })
    this.getItems()
  }

  /**
   * ข้อมูลสถานะแจ้งซ่อมทั้งหมด
   */
  getWorkStatus() {
    this.getCountWorkstatus()
    InformfixService.getWorkStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listStatus: data })
      }
    })
  }

  /**
   * ข้อมูลช่างซ่อมทั้งหมด
   */
  getTechnicianList() {
    TechnicainService.all().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listTechnichian: data })
      }
    })
  }

  /**
   * ข้อมูลโครงการทั้งหมด
   */
  getProjects() {
    this.setState({
      loadingProject: true,
    })
    ProjectService.all().then((pj) => {
      if (pj) {
        const dataProject = pj.data['data']
        this.setState({
          projects: dataProject,
          loadingProject: false,
        })
      }
    })
  }
  /**
   * นับสถานะใบแจ้งซ่อม
   */
  getCountWorkstatus() {
    InformfixService.countWorkstatus().then((rs) => {
      if (rs) {
        this.setState({
          countWorkstatus: rs.data,
        })
        this.props.informStore.countWorkstatus = rs.data
      }
    })

    /**
     * นับสถานะใบแจ้งซ่อมสำหรับหาจำนวนที่รอยืนยันและส่งกลับมานัดหมายใหม่
     */
    InformfixService.countProcess().then((rs) => {
      if (rs) {
        this.setState({
          countProcess: rs.data,
        })
        this.props.informStore.countProcess = rs.data
      }
    })
  }

  componentDidMount() {
    // ดึงรายชื่อโครงการทั้งหมดมาตอนเปิดหน้าครั้งแรก
    this.getProjects()

    // โหลดข้อมูลสถานะ
    this.getWorkStatus()

    // รายชื่อช่างซ่อมบำรุงทั้งหมด
    this.getTechnicianList()

    const qry = queryString.parse(this.props.location.search)
    let searchParams = this.state.searchParams

    // โครงการ
    if (qry.project_id) {
      searchParams.project_id = qry.project_id
      this.formRef.current.setFieldsValue({
        project_id: searchParams.project_id,
      })
    }
    // สถานะ
    if (qry.work_status) {
      searchParams.work_status = qry.work_status
      this.formRef.current.setFieldsValue({
        work_status: searchParams.work_status,
      })
    }
    // technician_id
    if (qry.technician_id) {
      searchParams.technician_id = qry.technician_id
      this.formRef.current.setFieldsValue({
        technician_id: searchParams.technician_id,
      })
    }

    // ประเภทค้นหา
    if (qry.f) {
      searchParams.f = qry.f
      this.formRef.current.setFieldsValue({
        f: searchParams.f,
      })
    }
    // คำค้นหา
    if (qry.f == 'date') {
      searchParams.q = qry.q
      if (searchParams.q) {
        this.formRef.current.setFieldsValue({
          q: Moment(searchParams.q).utc(7),
        })
      }
    } else {
      searchParams.q = qry.q
      this.formRef.current.setFieldsValue({
        q: qry.q,
      })
    }
    // console.log('qry', qry)
    // console.log('searchparams', searchParams)
    this.setState(
      {
        searchParams,
      },
      this.onSearch(),
    )
  }

  onChangeProject = (value) => {
    let searchParams = this.state.searchParams
    searchParams.project_id = value
    this.setState({
      searchParams,
    })
    console.log('onChangeProject', value)
    this.setQueryString()
  }
  onChangeTechnician = (value) => {
    let searchParams = this.state.searchParams
    searchParams.technician_id = value
    this.setState({
      searchParams,
    })
    console.log('onChangeTechnician', value)
    this.setQueryString()
  }
  onChangeWorkStatus = (value) => {
    let searchParams = this.state.searchParams
    searchParams.work_status = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangeSearchFeild = (value) => {
    this.formRef.current.setFieldsValue({
      q: null,
    })
    let searchParams = this.state.searchParams
    searchParams.f = value
    const nowDate = Moment()
      .utc(7)
      .format('YYYY-MM-DD')
    if (value == 'date') {
      searchParams.q = null
      this.formRef.current.setFieldsValue({
        q: null,
      })
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  onChangeQ = (e) => {
    e.persist()
    let searchParams = this.state.searchParams
    if (searchParams.f == 'date') {
    } else {
      searchParams.q = e.target.value
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangDate = (value) => {
    let searchParams = this.state.searchParams
    const date = Moment(value)
      .utc(7)
      .format('YYYY-MM-DD')
    if (Moment(value).isValid()) {
      searchParams.q = date
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  /**
   * set query params in url
   */
  setQueryString() {
    let params = queryString.stringify(this.state.searchParams)
    this.props.history.push({
      search: params,
    })
  }

  resetForm() {
    this.formRef.current.resetFields()
    this.setState({
      data: [],
      list: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: this.state.pagination.perPage,
        pageCount: 0,
      },
    })
    this.onSearch()
  }
  /**
   * นับสถานะใบแจ้งซ่อม
   */
  getCountAllStatus() {
    console.log('check count inform')
    InformfixService.countNewInform().then((rs) => {
      if (rs) {
        console.log('countNewInform', rs.data)
        const data = rs.data
        this.props.informStore.countNewInform = data.total
      }
    })
    InformfixService.count4task().then((rs) => {
      console.log('count4task', rs)
      if (rs) {
        const data = rs.data
        this.props.informStore.count4task = data.total
      }
    })
    InformfixService.countPostpone().then((rs) => {
      if (rs) {
        console.log('countPostpone', rs.data)
        const data = rs.data
        this.props.informStore.countPostpone = data.total
      }
    })
  }

  getInform(item) {
    // ข้อมูบใบแจ้งซ่อม
    InformfixService.view(item.id).then((inform) => {
      this.setState({
        inform: inform.data['data'],
      })
      this.props.informStore.setItem(this.state.inform)
    })

    // รูปภาพต่าง ๆ
    InformfixService.getGallery(item.id).then((gallery) => {
      this.setState({ photos: gallery })
      this.props.informStore.setGalleryItems(gallery)
    })

    // ข้อมูลบ้าน
    if (item.home) {
      HomeService.view(item.home.id).then((home) => {
        this.setState({
          visibleHomeDetail: true,
          homeDetail: home.data.data,
        })
        this.props.informStore.setHome(this.state.homeDetail)
      })
    }

    // jobs
    InformfixService.getJobs(item.id).then((rs) => {
      this.setState({
        informJobs: rs.data.data,
      })
    })
  }

  showModalAdd = () => {
    this.setState({ showFormAdd: true })
  }

  /**
   * ดูรายละเอียดใบแจ้งซ่อม
   */
  showModalView = (item) => {
    this.setState({
      showFormView: true,
      homeDetail: {},
    })
    this.getInform(item)
  }

  /**
   * แสดงแบบ Modal แก้ไขข้อูล
   */
  showModalEdit = (item, step = 0) => {
    this.props.informStore.setItem({})
    this.setState({
      editId: item.id,
      formStep: step,
    })
    InformfixService.view(item.id).then((rs) => {
      const data = rs.data.data
      this.setState({
        inform: data,
        showFormEdit: true,
      })
      this.props.informStore.setItem(data)
      console.log('showModaledit', this.state.showFormEdit)
    })
  }

  handleMenuDropDownClick = (e) => {
    if (e.key === '3') {
      this.setState({ visibleMenuDropDown: false })
    }
  }

  handleVisibleChangeMenuDropDown = (flag) => {
    this.setState({ visibleMenuDropDown: flag })
  }

  /**
   * เปลี่ยน Tabs
   */
  tabChange = (key) => {
    console.log('key', key)
    let searchParams = this.state.searchParams
    searchParams.work_status = key
    if (searchParams.f == 'date') {
      searchParams.q = null
    }
    this.setState({
      searchParams: searchParams,
    })
    this.formRef.current.setFieldsValue({
      work_status: searchParams.work_status,
      q: searchParams.q,
    })
    this.onSearch()
  }
  render() {
    const {
      initLoading,
      loading,
      loadingProject,
      pagination,
      homeDetail,
      inform,
      projects,
      listStatus,
      searchParams,
      galleries,
      photos,
    } = this.state
    const loadMore =
      !initLoading &&
      !loading &&
      pagination &&
      pagination.current < pagination.pageCount ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: 12,
            height: 32,
            lineHeight: '32px',
          }}
        >
          <Button
            type={Config.button.loadMore.type}
            block={Config.button.loadMore.block}
            shape={Config.button.loadMore.shape}
            onClick={this.onLoadMore}
            loading={loading}
          >
            {Config.button.loadMore.text}
          </Button>
          {''}
        </div>
      ) : null

    const searchForm = (
      <Form
        ref={this.formRef}
        id="informfixForm"
        // initialValue={{
        //   project_id: searchParams.project_id,
        //   q: searchParams.q,
        //   f: searchParams.f,
        //   work_status: searchParams.work_status,
        //   technichian_id: searchParams.technichian_id
        // }}
      >
        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
          >
            <Form.Item name="project_id">
              <Select
                loading={loadingProject}
                showSearch
                allowClear
                style={{ width: '100%' }}
                placeholder="-เลือกโครงการ-"
                // optionFilterProp="children"
                onChange={this.onChangeProject}
                // filterOption={(input, option) =>
                //   option.props.children
                //     .toLowerCase()
                //     .indexOf(input.toLowerCase()) >= 0
                // }
              >
                {projects.map((p, index) => (
                  <Option key={p.id} value={p.id}>
                    {p.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
          >
            <Form.Item name="work_status">
              <Select
                placeholder="-เลือกสถานะ-"
                style={{ width: '100%' }}
                onChange={this.onChangeWorkStatus}
                allowClear
              >
                {listStatus.map((status, key) => (
                  <Option key={key} value={status.value}>
                    {status.text}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
          >
            <Form.Item name="technichian_id">
              <Select
                placeholder="-เลือกช่าง-"
                style={{ width: '100%' }}
                onChange={this.onChangeTechnician}
                allowClear
              >
                {this.state.listTechnichian.map((tn, key) => (
                  <Option key={key} value={tn.id}>
                    {tn.firstname +
                      ' ' +
                      tn.lastname +
                      (tn.nickname ? '(' + tn.nickname + ')' : null)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
          >
            <Form.Item name="f">
              <Select
                placeholder="-ประเภทคำค้นหา-"
                style={{ width: '100%' }}
                onChange={this.onChangeSearchFeild}
                allowClear
              >
                <Option value="date">วันที่แจ้ง</Option>
                <Option value="home_no">บ้านเลขที่</Option>
                <Option value="plan_no">แปลงบ้าน</Option>
                <Option value="informer">ชื่อผู้แจ้ง</Option>
                <Option value="id">ID</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
          >
            <Form.Item name="q">
              {searchParams.f == 'date' ? (
                <DatePicker
                  format={formatDateSearch}
                  onChange={this.onChangDate}
                  allowClear={true}
                />
              ) : (
                <Input
                  placeholder="คำค้นหา.."
                  onChange={this.onChangeQ}
                  onPressEnter={this.onSearch}
                  allowClear
                />
              )}
            </Form.Item>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
          >
            <Button
              type="primary"
              loading={loading || initLoading}
              disabled={loading || initLoading}
             
              onClick={this.onSearch}
              title="ค้นหา"
              icon={<SearchOutlined />}
            ></Button>
            <Space /> <Space />
            <Button
              type="light"
              htmlType="reset"
              className="submit"
              onClick={() => this.resetForm()}
              title="รีเซ็ตการค้นหา"
              icon={<ReloadOutlined />}
            ></Button>
            <Space /> <Space />
            <Button
              type="light"
              onClick={() => this.showModalAdd()}
              title="เพิ่มใบแจ้งซ่อม"
              icon={<PlusCircleOutlined />}
            >
              เพิ่มใบแจ้งซ่อม
            </Button>
          </Col>
        </Row>
      </Form>
    )

    const showTotalStatus = (status) => (
      <React.Fragment>
        {this.state.countWorkstatus.map((item, key) =>
          status == item.work_status ? (
            <Badge count={item.total} key={key} />
          ) : null,
        )}
      </React.Fragment>
    )

    return (
      <React.Fragment>
        <PageHeader title="จัดการใบแจ้งซ่อม">
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={24}>
              <div> {searchForm}</div>

              <div style={{ marginTop: 10 }}>
                {this.state.listStatus
                  ? this.state.listStatus.map((i, key) => (
                      <Button
                        type="link"
                        onClick={() => this.tabChange(i.value)}
                        key={key}
                        size="small"
                        icon={<WifiOutlined />}
                      >
                        {i.text}

                        {i.value == STATUS_INFORMFIX_OPEN ||
                        i.value == STATUS_INFORMFIX_PROCEED
                          ? showTotalStatus(i.value)
                          : null}
                      </Button>
                    ))
                  : null}
                <Button
                  type="link"
                  onClick={() => this.tabChange('')}
                  size="small"
                  icon={<WifiOutlined />}
                >
                  ทุกสถานะ
                </Button>
              </div>

              {/* ///////////////////////////////////////// */}

              <PaginationDetail data={pagination} />
              
              <InformListComponent
                items={this.props.informStore.getItems}
                showMenu={{
                  editInform: true, // แก้ไขใบแจ้งซ่อม
                  cancelInform: true, // ยกเลิกไปแจ้งซ่อม
                  editJob: true, // แก้ไขคิวงาน
                  editInofrmStatus: true, // แก้ไขสถานะใบแจ้ง
                  manageTask: true, // จัดการคิวงาน
                  manageInform: true, // จัดการใบแจ้งซ่อม
                  confirmInform: true, // ยืนยันใบแจ้งซ่อม
                  // reconfirmInform: true, // ยืนยันนัดหมาย
                  confirmJob: true, // ยืนยันคิวงาน
                  closeInform: true, // ปิดคิวงานให้เสร็จ
                  showModalAdd: true, // แสดงหน้าเพิ่ม
                  postponeJob: true, // ปุ่มเลื่อนนัด
                  deleteInform: true, // ลบใบแจ้งซ่อม
                }}
                onWorkstatusChange={(data) => {
                  this.getCountWorkstatus()
                }}
                showFormAdd={this.state.showFormAdd}
                onFormAddClose={(value) => {
                  this.setState({
                    showFormAdd: value,
                  })
                  this.getCountWorkstatus()
                }}
                manageInform
                reload={() => this.onSearch()}
              />

              <PaginationDetail data={pagination} />

              <Pagination
                showQuickJumper
                defaultCurrent={1}
                current={this.state.pagination.current}
                total={this.state.pagination.total}
                pageSize={this.state.pagination.pageSize}
                onChange={(page, pageSize) => {
                  let pagination = this.state.pagination
                  pagination.current = page
                  pagination.pageSize = pageSize
                  this.setState({
                    pagination,
                  })
                  this.loadDataPagination()
                }}
                onShowSizeChange={(page, pageSize) => {
                  let pagination = this.state.pagination
                  pagination.current = page
                  pagination.pageSize = pageSize
                  this.setState({
                    pagination,
                  })
                  this.loadDataPagination()
                }}
              />
            </Col>
            {/* <Col xs={24} sm={24} md={12}>
            
            </Col> */}
          </Row>
        </PageHeader>
      </React.Fragment>
    )
  }
}

export default InformList
